import "Layouts/shopping";

import Swiper, { Pagination, Navigation } from 'swiper';

import "Ui/toggle";
import "Ui/tabs";
import 'Ui/slider';
import './shopping-cart-jquery';
import './presents';
import './points';
import { tippyAlert } from "Functions/tippy";

Swiper.use([Pagination, Navigation]);

document.addEventListener('DOMContentLoaded', function() {
    const urlString = window.location.href.toLowerCase(),
        urlObject = new URL(urlString),
        triggerImport = urlObject.searchParams.get('xlsx-import'), //xlsx
        triggerAutocomplete = urlObject.searchParams.get('quick');

    const btnImportElem = document.querySelector('.js-import-form-input'),
        autocompleteHolder = document.querySelector('.js-cart-autocomplete');

    if (btnImportElem && triggerImport) {
        setTimeout(() => {
            window.scrollTo({
                top: btnImportElem.offsetTop + btnImportElem.offsetHeight,
                behavior: 'smooth'
            });
        }, 250);
    }

    if (autocompleteHolder && triggerAutocomplete) {
        setTimeout(() => {
            window.scrollTo({
                top: autocompleteHolder.offsetTop + autocompleteHolder.offsetHeight,
                behavior: 'smooth'
            });
        }, 250);
    }
});

/**
 * Recalculate price of product types
 */
rEvent.on('Custom.Cart.updatedItem', ({ input, response }) => {
    const pricesWithVat = window.Eshop.options.pricesWithVat

    // product types total update
    if (document.querySelector('.js-type-total')) {
        const productTypes = Object.values(response.products).reduce(function (acc, obj) {
            let key = obj.product_type_id;

            if (!acc[key]) {
                acc[key] = [];
            }

            acc[key].push(Math.round(obj[pricesWithVat ? 'price_vat' : 'price'] * obj.quantity * 100) / 100);

            return acc;
        }, {});

        for (const productTypeId in productTypes) {
            const typeTotal = document.querySelector(`.js-type-total[data-type-id="${productTypeId}"]`);
            let tmpTotal = 0;

            for (const productPrice of productTypes[productTypeId]) {
                tmpTotal += productPrice;
            }

            typeTotal.innerHTML = Format.price(tmpTotal);
        }
    }
});

/**
 * Max quantity message
 */
document.addEventListener('DOMContentLoaded', function() {
    const updateQuantity = (event) => {
        const rSpinner = event.detail.rSpinner
        const quantity = rSpinner.getParsedValue()
        const oldValue = rSpinner.getParsedOldValue()
        const max = rSpinner.max
        const spinDirection = rSpinner.spinDirection

        if (quantity == oldValue && quantity == max && spinDirection == 'up' || quantity == max && spinDirection === null) {
            Eshop.tippyAlert(rSpinner.input, rSpinner.dataset.maxMessage.replaceAll(':productStock', rSpinner.max), {
                theme: 'warning'
            }, 20 * 1000);
        }
    }
    for (const rSpinner of document.querySelectorAll('r-spinner')) {
        rSpinner.addEventListener('stop', updateQuantity)
        rSpinner.addEventListener('changed', updateQuantity)
    }
});

rEvent.on('Cart.totals.after_updated', function(data) {
    const customTypes = [
        {
            selector: '[data-type="custom-club-discount"]',
            property: 'custom_club_discount'
        },
    ];

    for (const type of customTypes) {
        const cartElements = document.querySelectorAll(`[data-element="cart"]${type.selector}`)
        const value = data[type.property]

        for (const cartElement of cartElements) {
            const elementHolder = cartElement.closest('.js-cart-element-holder')

            if (elementHolder) {
                elementHolder.classList.toggle('hidden', value === 0)
            }

            cartElement.innerHTML = Format.price(value)
        }
    }
});

rEvent.on('Cart.after.updateQuantity', function (input, response) {
    if (!response) {
        return
    }

    if (!input._tippy) {
        tippyAlert(
            input,
            response.message
        )
    }

    if (!response.status) {
        return
    }

    if (response.products) {
        const responseProducts = Object.values(response.products)
        let productsCount = 0;
        let productsQuantityCount = 0;

        for (const item of responseProducts) {
            // update quantity for notSaleable product (gift)
            if (item.is_not_saleable) {
                $('[data-element="cartItem"]')
                    .filter('[data-type="quantity"]')
                    .filter('[data-id="' + item.id + '"]')
                    .html(Format.integer(item.quantity));
            }

            if (!item.type) {
                $('[data-element="cartItem"]')
                    .filter('[data-type="finalPrice"]')
                    .filter('[data-id="' + item.id + '"]')
                    .html(Format.price(item.price));

                $('[data-element="cartItem"]')
                    .filter('[data-type="finalPriceVat"]')
                    .filter('[data-id="' + item.id + '"]')
                    .html(Format.price(item.price_vat));

                $('[data-element="cartItem"]')
                    .filter('[data-type="price"]')
                    .filter('[data-id="' + item.id + '"]')
                    .html(Format.price(item.price));

                $('[data-element="cartItem"]')
                    .filter('[data-type="priceVat"]')
                    .filter('[data-id="' + item.id + '"]')
                    .html(Format.price(item.price_vat));
            }

            if (item.type == 'product' || item.type == 'product_set') {
                if (!item.id.endsWith('-basic')) {
                    productsCount++;
                }

                productsQuantityCount += item.quantity;
            }
        }

        document.querySelector('.js-totals-products-count').innerHTML = productsCount;
        document.querySelector('.js-totals-products-quantity-count').innerHTML = productsQuantityCount;
    }

    if (response.custom_mapped_items) {
        for (const mappedItem of Object.values(response.custom_mapped_items)) {
            if (!mappedItem.is_action || !mappedItem.custom_action_stock) {
                continue
            }

            const basicQuantity = mappedItem.custom_quantity_together - mappedItem.custom_action_stock

            let finalPrice = mappedItem.quantity * mappedItem.price
            let finalPriceVat = mappedItem.quantity * mappedItem.price_vat
            let oldFinalPrice = mappedItem.quantity * mappedItem.old_price
            let oldFinalPriceVat = mappedItem.quantity * mappedItem.old_price_vat

            if (basicQuantity > 0) {
                finalPrice += basicQuantity * mappedItem.custom_basic_price
                finalPriceVat += basicQuantity * mappedItem.custom_basic_price_vat
                oldFinalPrice += basicQuantity * mappedItem.custom_basic_price
                oldFinalPriceVat += basicQuantity * mappedItem.custom_basic_price_vat
            }

            $('[data-element="cartItem"]')
                .filter('[data-type="finalPrice"]')
                .filter('[data-id="' + mappedItem.cart_id + '"]')
                .html(Format.price(finalPrice));

            $('[data-element="cartItem"]')
                .filter('[data-type="finalPriceVat"]')
                .filter('[data-id="' + mappedItem.cart_id + '"]')
                .html(Format.price(finalPriceVat));

            $('[data-element="cartItem"]')
                .filter('[data-type="oldFinalPrice"]')
                .filter('[data-id="' + mappedItem.cart_id + '"]')
                .html(Format.price(oldFinalPrice));

            $('[data-element="cartItem"]')
                .filter('[data-type="oldFinalPriceVat"]')
                .filter('[data-id="' + mappedItem.cart_id + '"]')
                .html(Format.price(oldFinalPriceVat));

            $('[data-element="cartItem"]')
                .filter('[data-type="customBasicQuantity"]')
                .filter('[data-id="' + mappedItem.cart_id + '"]')
                .html(basicQuantity);

            $('[data-element="cartItem"]')
                .filter('[data-type="customBasicPrice"]')
                .filter('[data-id="' + mappedItem.cart_id + '"]')
                .html(Format.price(mappedItem.custom_basic_price));

            $('[data-element="cartItem"]')
                .filter('[data-type="customBasicPriceVat"]')
                .filter('[data-id="' + mappedItem.cart_id + '"]')
                .html(Format.price(mappedItem.custom_basic_price_vat));

            $('.js-linked-unit-price')
                .filter('[data-cart-id="' + mappedItem.cart_id + '"]')
                .toggleClass('h-nodisplay', basicQuantity <= 0);

            // if (
            //     item.type == 'product'
            //     && item.is_action
            //     && item.custom_action_stock
            //     && !item.id.endsWith('-basic')
            // ) {
            //     const cartId = item.id;
            //     const linkedBasicProduct = responseProducts.find(item => item.id == `${cartId}-basic`);

            // }
        }
    }
});